import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import shareUrl from '../helpers/shareUrl';
export default class ShareDropdownButton extends Component {
  view() {
    return m(Button, {
      onclick: () => shareUrl(this.attrs.url, this.attrs.discussionTitle),
      className: "Button davwheat-ShareDropdownButton",
      icon: "fas fa-share-alt"
    }, app.translator.trans('davwheat-share.lib.share_a11y_label'));
  }
}
flarum.reg.add('davwheat-share', 'common/components/ShareDropdownButton', ShareDropdownButton);